class CoreDrag extends HTMLElement {

    constructor() {
        super();
        this.data = {
            startIndex: 0,
            isTouch: false,
            width: 0,
            slideWidth: 0,
            shift: 0,

            isGrabbing: false,
            startX: 0,
            pageStartX: 0,
            isAuto: false,
            hasReachedEnd: false
        }
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onLinkMouseUp = this.onLinkMouseUp.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.onScroll = this.onScroll.bind(this);
    }

    next() {
        this.onAutoSlideStop()
        this.data.shift += this.data.slideWidth
        this.$wrapperOuter.scrollLeft = this.data.shift
        this.updateSlides();
    }

    prev() {
        this.onAutoSlideStop()
        this.data.shift -= this.data.slideWidth
        this.$wrapperOuter.scrollLeft = this.data.shift
        this.updateSlides();
    }

    onAutoSlideStart() {
        this.classList.add('is-auto')
        this.updateSlides()
        this.autoTimer = setTimeout(() => {
            this.data.shift = this.data.hasReachedEnd ? 0 : this.data.shift + this.data.slideWidth
            this.$wrapperOuter.scrollLeft = this.data.shift
            this.onAutoSlideStart()
        }, 5 * 1000)
    }

    onAutoSlideStop() {
        if(this.data.isAuto) {
            clearTimeout(this.autoTimer)
            this.classList.remove('is-auto')
            this.data.isAuto = false
        }
    }

    onResize() {
        this.data.width = this.$wrapperInner.offsetWidth - this.$wrapperOuter.offsetWidth
        this.data.slideWidth = this.$slides[0].offsetWidth + 24
    }

    onMouseEnter() {
        this.onAutoSlideStop()
    }

    onMouseDown(event) {
        this.onAutoSlideStop()
        this.data.isGrabbing = true
        this.data.startX = event.pageX - this.data.shift * -1
        this.data.pageStartX = event.pageX
        this.$wrapperOuter.classList.add('is-grabbing')
        this.$wrapperOuter.style.scrollBehavior = 'auto'
    }

    onMouseMove(event) {
        if(this.data.isGrabbing) {
            this.data.shift = (event.pageX - this.data.startX) * -1
            this.$wrapperOuter.scrollLeft = this.data.shift
            this.updateSlides()
        }
    }

    onMouseUp() {
        this.onMouseLeave()
    }

    onMouseLeave() {
        this.$wrapperOuter.classList.remove('is-grabbing')
        this.data.isGrabbing = false
        this.$wrapperOuter.style.scrollBehavior = 'smooth'
    }

    onScroll(event) {
        this.data.shift = event.currentTarget.scrollLeft
        this.updateSlides()
    }

    onLinkMouseUp(event) {
        event.preventDefault()

        if(Math.abs(this.data.pageStartX - event.pageX) <= 5) {
            window.location.href = event.currentTarget.getAttribute('href')
        }
    }

    onLinkClick(event) {
        event.preventDefault()
    }

    updateSlides() {
        this.data.shift = Math.min(Math.max(this.data.shift, 0), this.data.width) //clamp shift

        this.data.hasReachedEnd = this.data.shift >= this.data.width

        this.$nextBtn.removeAttribute('disabled')
        this.$prevBtn.removeAttribute('disabled')

        if(this.data.shift === 0) {
            this.$prevBtn.setAttribute('disabled', '')
        } else if(this.data.shift === this.data.width) {
            this.$nextBtn.setAttribute('disabled', '')
        }
    }

    connectedCallback() {
        this.$slides = this.querySelectorAll('[data-drag-slide]')
        this.$links = this.querySelectorAll('[data-drag-link]')
        this.$wrapperInner = this.querySelector('[data-drag-wrapper-inner]')
        this.$wrapperOuter = this.querySelector('[data-drag-wrapper-outer]')
        this.$prevBtn = this.querySelector('[data-drag-prev-btn]')
        this.$nextBtn = this.querySelector('[data-drag-next-btn]')

        this.$prevBtn.addEventListener('click', this.prev, false)
        this.$nextBtn.addEventListener('click', this.next, false)
        this.$wrapperOuter.addEventListener('scroll', this.onScroll, false)
        window.addEventListener('resize', this.onResize, false)

        this.data.isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
        this.data.isAuto = this.getAttribute('data-auto') === 'true'
        this.data.startIndex = +this.getAttribute('data-start-index') || 0

        if(!this.data.isTouch) {
            this.$wrapperInner.addEventListener('mouseenter', this.onMouseEnter, false)
            this.$wrapperOuter.addEventListener('mousedown', this.onMouseDown, false)
            this.$wrapperOuter.addEventListener('mouseleave', this.onMouseLeave, false)
            this.$wrapperOuter.addEventListener('mouseup', this.onMouseUp, false)
            this.$links.forEach((link) => {
                link.addEventListener('click', this.onLinkClick, false)
                link.addEventListener('mouseup', this.onLinkMouseUp, false)
            })
            window.addEventListener('mousemove', this.onMouseMove, false)
        }

        this.onResize()

        setTimeout(() => {
            this.$wrapperOuter.style.scrollBehavior = 'auto'
            this.data.shift = this.data.slideWidth * this.data.startIndex
            this.$wrapperOuter.scrollLeft = this.data.shift
            this.$wrapperOuter.style.scrollBehavior = 'smooth'
            
            if(this.data.isAuto) {
                this.onAutoSlideStart()
            } else {
                this.updateSlides()
            }
        }, 50)
    }

    disconnectedCallback() {
        this.$prevBtn.removeEventListener('click', this.prev, false);
        this.$nextBtn.removeEventListener('click', this.next, false);
        window.removeEventListener('resize', this.onResize, false);
    }

}

customElements.define('core-drag', CoreDrag);


console.log('<core-drag> loaded');